import React from "react";
import ButtonBase from "@material-ui/core/ButtonBase";
import withStyles from "@material-ui/core/styles/withStyles";
import Colors from "../../constants/Colors";
import Highlight from "./Highlight";

const styles = theme => ({
  list: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: 5,
    marginRight: 5,
    marginTop: 20
  },
  name: {
    marginTop: 7,
    marginBottom: 5,
    color: Colors.text,
    fontSize: 13
  },
  experience: {
    margin: 0
  },
  accent: {
    color: Colors.main,
    fontWeight: "bold",
    fontSize: 13
  },
  smallName: {
    fontSize: 8
    // marginTop:
  },
  roundIndicator: {
    width: 28,
    height: 28,
    borderRadius: 14,
    border: "solid",
    borderWidth: 2,
    borderColor: "#fff",
    backgroundColor: Colors.green,
    position: "absolute",
    top: -10,
    right: -5,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    fontWeight: "bold",
    fontSize: 13
  }
});

const Avatar = ({
  item,
  classes,
  id,
  picture,
  firstName,
  lastName,
  onClick,
  isSelected,
  isMyTeam,
  strong,
  experience,
  totalDoneSinceAWeek
}) => {
  return (
    <ButtonBase
      key={id}
      onClick={onClick}
      style={{
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        marginLeft: strong ? 5 : 0,
        marginRight: strong ? 5 : 0,
        marginTop: strong ? 5 : 0,
        marginBottom: strong ? 10 : 0
      }}
    >
      {strong && (
        <div
          className={classes.roundIndicator}
          style={{
            backgroundColor: totalDoneSinceAWeek > 0 ? Colors.green : "orange"
          }}
        >
          {totalDoneSinceAWeek}
        </div>
      )}
      <img
        alt={id}
        style={{
          height: isSelected ? 50 : 120,
          width: isSelected ? 50 : 90,
          marginRight: 5,
          margin: isSelected ? "2 2 0 2" : "0 5 0 0",
          borderRadius: isSelected ? 25 : 8,
          border: isSelected ? "solid" : "",
          borderWidth: isSelected ? 2 : 0,
          borderColor: Colors.main
        }}
        src={picture}
      />
      {isSelected && (
        <p className={`${classes.name} ${isSelected && classes.smallName}`}>
          {firstName || "Sans nom"}
        </p>
      )}
      {isMyTeam && (
        <p className={classes.name} style={{ fontWeight: "bold" }}>
          {firstName || "Sans nom"}
        </p>
      )}
      {strong && (
        <p className={classes.experience}>
          <span className={classes.accent}>{experience}</span>
          {`${experience > 1 ? " actions" : " action"}`}
        </p>
      )}
      {!isSelected && !isMyTeam && (
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            alignContent: "center",
            alignItems: "flex-start"
          }}
        >
          <p className={classes.name}>
            <Highlight attribute="name" hit={item} />
          </p>
          {/* <p className={classes.name}>{lastName}</p> */}
        </div>
      )}
    </ButtonBase>
  );
};
export default withStyles(styles)(Avatar);
